import { Download } from "lucide-react"

import { Button } from "@/components/ui/button"

interface Props {
  url: string
  contentType?: string | null
}

function isImageContentType(contentType?: string | null) {
  return contentType?.startsWith("image/") ?? false
}

export default function MediaExportButtons({ url, contentType }: Props) {
  if (!isImageContentType(contentType)) {
    return null
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button asChild variant="outline" size="sm">
        <a href={url} download target="_blank" rel="noopener noreferrer">
          <Download className="size-3.5" aria-hidden />
          Download
        </a>
      </Button>
    </div>
  )
}
